module.exports = __webpack_public_path__ + "static/rto-guide-624d0e25345954f17694f2e8b6ed94aa.png";